// Přihlašovací obrazovka. V produkci tlačítko „Přihlásit přes Microsoft“ (backend dělá OAuth flow
// jako Projektovník), ve vývoji výběr testovacího uživatele.
import { useEffect, useState } from 'react';
import { MicrosoftOutlookLogoIcon } from '@phosphor-icons/react';
import { Alert, Button, Select, Spinner } from '@smworks-cz/ui-kit';
import { ROLE_LABEL, type Role } from '@sam/shared';
import { api } from '../lib/api';

type DevUser = { email: string; name: string; role: Role };

function useDevUsers() {
  const [users, setUsers] = useState<DevUser[] | null>(null);
  useEffect(() => {
    api<{ users: DevUser[] }>('GET', '/dev/users')
      .then((r) => setUsers(r.users))
      .catch(() => setUsers([]));
  }, []);
  return users;
}

async function devLogin(email: string) {
  await api('POST', '/dev/login', { email });
  window.location.reload();
}

export function DevUserSwitch({ current }: { current: string }) {
  const users = useDevUsers();
  if (!users) return <Spinner size="sm" />;
  return (
    <Select
      value={current}
      onChange={(v) => v && v !== current && void devLogin(String(v))}
      options={users.map((u) => ({ value: u.email, label: `${u.name} (${ROLE_LABEL[u.role]})` }))}
      size="sm"
      style={{ minWidth: 240 }}
    />
  );
}

export function LoginScreen({ mode }: { mode: 'microsoft' | 'dev' }) {
  const error = new URLSearchParams(window.location.search).get('login_error');
  const returnTo = window.location.pathname + window.location.search.replace(/[?&]login_error=[^&]*/, '');
  return (
    <div className="login">
      <div className="login-card">
        <div className="brand big">
          <img src="/logo.png" alt="" />
          <b>SAM</b>
        </div>
        <p className="muted">Firemní data, hodiny a projekty v jednom chatu.</p>
        {error && (
          <Alert variant="error" title="Přihlášení se nepovedlo">
            {error}
          </Alert>
        )}
        {mode === 'microsoft' ? (
          <Button
            size="lg"
            fullWidth
            icon={<MicrosoftOutlookLogoIcon size={20} />}
            href={`/auth/login?returnTo=${encodeURIComponent(returnTo.startsWith('/') ? returnTo : '/')}`}
          >
            Přihlásit přes Microsoft
          </Button>
        ) : (
          <DevLoginList />
        )}
        {mode === 'microsoft' && (
          <a className="muted small" href="/auth/login?switch=1">
            Přihlásit jiným účtem
          </a>
        )}
      </div>
    </div>
  );
}

function DevLoginList() {
  const users = useDevUsers();
  if (!users) return <Spinner />;
  return (
    <div className="dev-login">
      <p className="small muted">Vývojový režim (není nastavené MS_TENANT_ID). Vyberte testovacího uživatele:</p>
      {users.map((u) => (
        <Button key={u.email} variant="secondary" fullWidth onClick={() => void devLogin(u.email)}>
          {u.name} · {ROLE_LABEL[u.role]}
        </Button>
      ))}
    </div>
  );
}
